var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentOptStatus === _vm.optStatusDefs.normal,
              expression: "currentOptStatus===optStatusDefs.normal"
            }
          ],
          staticClass: "main-content"
        },
        [
          _c(
            "search-item",
            {
              ref: "searchItem",
              attrs: {
                "show-more-scheme": true,
                "show-simple": true,
                "expand-adv": true,
                "search-item-code": _vm.$t("Clearing.AccountStatements"),
                "config-module": "505",
                "grid-config-module": "190904",
                "auto-init": false,
                "is-append-query": true,
                "custom-search-items": _vm.customSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Clearing.QuickSearchReconciliationBillNumber"
                )
              },
              on: {
                query: _vm.fetchData,
                advToggle: _vm.scrollCallback,
                perConfigChange: function(value) {
                  _vm.perConfigName = value
                },
                refreshGrid: function() {
                  _vm.gridRefreshId += 1
                },
                defaultSearchItemsChange: function(value) {
                  _vm.defaultSearchItems = value
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "searchAreaHeader",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "app-main-inner-row  extension-conditions-form"
                        },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "basicForm",
                              attrs: { inline: "", "label-position": "left" }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: [
                                        "filter_ACTBilling_arBillingGroups",
                                        "filter_ACTBilling_apBillingGroups",
                                        "filter_ACTBilling_allBillingGroups"
                                      ],
                                      expression:
                                        "['filter_ACTBilling_arBillingGroups','filter_ACTBilling_apBillingGroups','filter_ACTBilling_allBillingGroups']"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_PaymentReceiveMethodP"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "10" },
                                      model: {
                                        value: _vm.searchConditions.paymentType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.searchConditions,
                                            "paymentType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchConditions.paymentType"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: [
                                                "filter_ACTBilling_arBillingGroups"
                                              ],
                                              expression:
                                                "['filter_ACTBilling_arBillingGroups']"
                                            }
                                          ],
                                          attrs: { label: 1 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_Receivable"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: [
                                                "filter_ACTBilling_apBillingGroups"
                                              ],
                                              expression:
                                                "['filter_ACTBilling_apBillingGroups']"
                                            }
                                          ],
                                          attrs: { label: 0 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Dues")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: [
                                                "filter_ACTBilling_allBillingGroups"
                                              ],
                                              expression:
                                                "['filter_ACTBilling_allBillingGroups']"
                                            }
                                          ],
                                          attrs: { label: -1 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("CargoMsg.Cargo_All"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: [
                                        "filter_ACTBilling_overseaBillingGroups",
                                        "filter_ACTBilling_localBillingGroups"
                                      ],
                                      expression:
                                        "['filter_ACTBilling_overseaBillingGroups','filter_ACTBilling_localBillingGroups']"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_BillOfType")
                                  }
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { no: "11" },
                                      model: {
                                        value:
                                          _vm.searchConditions.chargeTypeGroup,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.searchConditions,
                                            "chargeTypeGroup",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchConditions.chargeTypeGroup"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: [
                                                "filter_ACTBilling_localBillingGroups"
                                              ],
                                              expression:
                                                "['filter_ACTBilling_localBillingGroups']"
                                            }
                                          ],
                                          attrs: { label: 0 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Domestic")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          directives: [
                                            {
                                              name: "permission",
                                              rawName: "v-permission",
                                              value: [
                                                "filter_ACTBilling_overseaBillingGroups"
                                              ],
                                              expression:
                                                "['filter_ACTBilling_overseaBillingGroups']"
                                            }
                                          ],
                                          attrs: { label: 1 }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_International"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.useOrderCenterMode,
                                      expression: "useOrderCenterMode"
                                    }
                                  ],
                                  attrs: { "label-width": "0" }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: { no: "12" },
                                      model: {
                                        value:
                                          _vm.searchConditions.internalCharge,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.searchConditions,
                                            "internalCharge",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchConditions.internalCharge"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_InternalCharges"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_StatementDateP"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  no: "13",
                                                  type: "date",
                                                  clearable: false,
                                                  "value-format": "yyyy-MM-dd",
                                                  "picker-options":
                                                    _vm.pickerOptions
                                                },
                                                model: {
                                                  value:
                                                    _vm.searchConditions
                                                      .inputDateStart,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.searchConditions,
                                                      "inputDateStart",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "searchConditions.inputDateStart"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("el-col", { attrs: { span: 1 } }, [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "12px" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_To")
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 8 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  no: "14",
                                                  type: "date",
                                                  clearable: "",
                                                  "value-format": "yyyy-MM-dd",
                                                  "picker-options":
                                                    _vm.pickerOptions
                                                },
                                                model: {
                                                  value:
                                                    _vm.searchConditions
                                                      .inputDateEnd,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.searchConditions,
                                                      "inputDateEnd",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "searchConditions.inputDateEnd"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: {
                                            "padding-left": "5px"
                                          },
                                          attrs: { span: 7 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  attrs: { no: "15" },
                                                  model: {
                                                    value:
                                                      _vm.allowTwoYearOutside,
                                                    callback: function($$v) {
                                                      _vm.allowTwoYearOutside = $$v
                                                    },
                                                    expression:
                                                      "allowTwoYearOutside"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Billing.billingJob_lockCheckBoxDate"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm.currentOptStatus === _vm.optStatusDefs.normal
                ? _c(
                    "div",
                    { attrs: { slot: "operations" }, slot: "operations" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACTBilling_editBillingGroup"],
                              expression:
                                "['button_ACTBilling_editBillingGroup']"
                            }
                          ],
                          attrs: { no: "1", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.showBillGroupView(
                                undefined,
                                true,
                                false
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACTBilling_deleteBillingGroup"],
                              expression:
                                "['button_ACTBilling_deleteBillingGroup']"
                            }
                          ],
                          attrs: { no: "2", type: "danger" },
                          on: {
                            click: function($event) {
                              return _vm.deleteBillGroup()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACTBilling_editBillingGroup"],
                              expression:
                                "['button_ACTBilling_editBillingGroup']"
                            }
                          ],
                          attrs: { no: "3", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.showBillGroupView(
                                undefined,
                                true,
                                true
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACTBilling_confirmBillingGroup"],
                              expression:
                                "['button_ACTBilling_confirmBillingGroup']"
                            }
                          ],
                          attrs: { no: "4", type: "primary" },
                          on: { click: _vm.confirmBillGroup }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: [
                                "button_ACTBilling_unconfirmBillingGroup"
                              ],
                              expression:
                                "['button_ACTBilling_unconfirmBillingGroup']"
                            }
                          ],
                          attrs: { no: "5", type: "primary" },
                          on: { click: _vm.unConfirmBillGroup }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelConfirm")))]
                      ),
                      _c(
                        "el-dropdown",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACTBilling_printBillingGroup"],
                              expression:
                                "['button_ACTBilling_printBillingGroup']"
                            }
                          ],
                          staticStyle: { margin: "0 5px" },
                          attrs: {
                            no: "6",
                            "split-button": "",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.printBillingGroup(
                                _vm.$t("CargoMsg.Cargo_Print")
                              )
                            },
                            command: _vm.printBillingGroup
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Print")) + " "
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "Clearing.PrintAccordingAccountNumber"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Clearing.PrintAccordingAccountNumber"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.role.createInvoiceFromBillingGroup ||
                      _vm.role.createInvoiceApFromBillingGroup
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "7", type: "primary" },
                              on: { click: _vm.makeInvoiceEvent }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_Invoicing")) +
                                  "/" +
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_CollectInvoice")
                                  )
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACTBilling_writeoffBillingGroup"],
                              expression:
                                "['button_ACTBilling_writeoffBillingGroup']"
                            }
                          ],
                          attrs: { no: "8", type: "primary" },
                          on: { click: _vm.writeoffHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WriteOff")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACTBilling_payauthBillingGroup"],
                              expression:
                                "['button_ACTBilling_payauthBillingGroup']"
                            }
                          ],
                          attrs: { no: "9", type: "primary" },
                          on: { click: _vm.doBillPayment }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ApplyForPayment"))
                          )
                        ]
                      ),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            type: "primary",
                            content: _vm.$t("Billing.billing_recheckTip"),
                            placement: "bottom"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn",
                              staticStyle: {
                                display: "inline-block",
                                "margin-right": "5px",
                                "margin-left": "5px"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "permission",
                                      rawName: "v-permission",
                                      value: ["button_ACTBilling_recheck"],
                                      expression:
                                        "['button_ACTBilling_recheck']"
                                    }
                                  ],
                                  attrs: { no: "16", type: "primary" },
                                  on: { click: _vm.doRecheck }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Billing.billing_recheck"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: ["button_ACTBilling_cancelRecheck"],
                              expression: "['button_ACTBilling_cancelRecheck']"
                            }
                          ],
                          attrs: { no: "17", type: "primary" },
                          on: { click: _vm.doCancelRecheck }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Billing.billing_cancelRecheck"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName: "v-permission",
                              value: [
                                "button_ACTBilling_billingGroupBatchUpload"
                              ],
                              expression:
                                "['button_ACTBilling_billingGroupBatchUpload']"
                            }
                          ],
                          attrs: { type: "primary", no: "batchUpload" },
                          on: { click: _vm.batchUploadFileHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_BatchUploadFile"))
                          )
                        ]
                      ),
                      _vm.$checkPermission([
                        "button_ACTBilling_billingGroupInvoicePool"
                      ]) && _vm.searchConditions.paymentType === 0
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                no: "showInvoicePoolDialog"
                              },
                              on: { click: _vm.showInvoicePoolDialog }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_InvoicePoolReceiving")
                                )
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid-wrapper", {
                attrs: {
                  "config-module": "190904",
                  "per-config-name": _vm.perConfigName,
                  "refresh-id": _vm.gridRefreshId,
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.dynamicColumnDefs,
                  "sum-column-defs": _vm.sumColumnDefsComputed,
                  "pre-column-state-callback": _vm.preColumnStateCallback,
                  "row-data": _vm.rowData,
                  "total-config": _vm.totalConfig,
                  "show-row-groups": _vm.dataListDragGroup
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "pagination-wrapper",
              attrs: { id: "footer-wrapper-tab-billing-group" }
            },
            [
              _c(
                "div",
                {
                  class: [_vm.shouldFixed ? "fixedBottom" : ""],
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "flex-wrap": "wrap"
                  }
                },
                [
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.dataShow && _vm.totalAmountToCurrency.labelText,
                        expression:
                          "dataShow && totalAmountToCurrency.labelText"
                      }
                    ],
                    domProps: {
                      textContent: _vm._s(_vm.totalAmountToCurrency.labelText)
                    }
                  }),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.dataShow &&
                          _vm.totalAmountToCurrency.selectionCountLabel,
                        expression:
                          "dataShow && totalAmountToCurrency.selectionCountLabel"
                      }
                    ],
                    domProps: {
                      textContent: _vm._s(
                        _vm.totalAmountToCurrency.selectionCountLabel
                      )
                    }
                  }),
                  _c("charge-currency-total-group", {
                    key: 1,
                    ref: "chargeCurrencyTotalGroup1",
                    attrs: {
                      mode: "group",
                      type: _vm.totalAmountToCurrency.type,
                      "data-provider": _vm.totalAmountToCurrency.dataProvider,
                      "data-field": "amount",
                      "currency-field": _vm.totalAmountToCurrency.currencyField,
                      "rate-field": _vm.totalAmountToCurrency.rateField,
                      "ar-field": "ar",
                      "arap-group": false,
                      "show-wht": _vm.showWhtTax
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditions.total,
                      layout: "total"
                    }
                  })
                ],
                1
              ),
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery,
                    expression: "!appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "190904",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.currentOptStatus === _vm.optStatusDefs.billGroupDetailView
        ? _c("bill-group-detail", {
            attrs: {
              "view-source": "billGroup",
              "billing-group-uuid": _vm.billingGroupUuid,
              "view-billing-group": _vm.viewBillingGroup,
              location: _vm.location,
              "show-wht": _vm.showWhtTax
            },
            on: {
              backBillingGroupList: _vm.backBillingGroupList,
              cancel: function($event) {
                _vm.currentOptStatus = _vm.optStatusDefs.normal
              },
              writeoffHandler: _vm.writeoffHandler
            }
          })
        : _vm._e(),
      _vm.writeOffDialog.visible
        ? _c("write-off-dialog", {
            ref: "dgWriteoff",
            attrs: {
              location: _vm.location,
              visible: _vm.writeOffDialog.visible,
              title: _vm.title,
              properties: _vm.properties
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.writeOffDialog, "visible", $event)
              },
              writeoffSuccessHandler: _vm.reloadData
            }
          })
        : _vm._e(),
      _c("bill-payment-dialog", {
        ref: "billPayment",
        attrs: {
          "open-sap-config": false,
          visible: _vm.showBillPaymentDialog,
          "create-submit": true,
          location: _vm.location,
          step: "step2",
          mode: "overview"
        },
        on: {
          "update:visible": function($event) {
            _vm.showBillPaymentDialog = $event
          },
          cancel: _vm.cancelBillPayment
        }
      }),
      _c("make-invoice-dialog", {
        ref: "invoice",
        attrs: { "view-source": "billGroup", location: _vm.location },
        on: { reloadData: _vm.reloadData }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("batch-upload-file", {
        attrs: {
          visible: _vm.cloudFile.visible,
          "redis-key": _vm.cloudFile.redisKey,
          "job-num": _vm.cloudFile.num,
          "page-source": "tabBillingGroup",
          lob: _vm.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          }
        }
      }),
      _vm.invoicePoolDialog.visible
        ? _c("invoice-pool-dialog", {
            attrs: {
              visible: _vm.invoicePoolDialog.visible,
              "seller-tax-name-default-value":
                _vm.invoicePoolDialog.sellerTaxNameDefaultValue,
              "selected-entities": _vm.invoicePoolDialog.selectedEntities,
              "make-invoice-method": _vm.invoicePoolDialog.makeInvoiceMethod,
              operation: _vm.invoicePoolDialog.operation,
              source: _vm.invoicePoolDialog.source
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoicePoolDialog, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }